import { useState } from "react";
import { Loader2, ClipboardCheck } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const C = { ok: "bg-[#10B981]/15 text-[#065F46]", warn: "bg-[#F59E0B]/15 text-[#92400E]", fail: "bg-[#EF4444]/15 text-[#991B1B]" };

export default function Preflight() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => { setBusy(true); try { setD((await api.get("/superadmin/release/preflight")).data); } catch (e) { toast.error(e.response?.data?.detail || "Verifica non riuscita"); } finally { setBusy(false); } };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-2" data-testid="sa-preflight">
      <div className="flex flex-wrap items-center gap-2"><ClipboardCheck className="h-4 w-4 text-slate-600" /><p className="text-sm font-semibold text-slate-800 flex-1">Verifica pre-rilascio (sola lettura, nessun Re-publish)</p>
        <Button size="sm" variant="outline" onClick={run} disabled={busy} className="h-7 text-xs" data-testid="preflight-run">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : "Esegui verifica"}</Button></div>
      {d && (
        <>
          <p className="text-xs text-slate-600" data-testid="preflight-summary">OK {d.summary.ok} · da verificare {d.summary.warn} · bloccanti in produzione {d.summary.fail} · {d.note}</p>
          <div className="space-y-1">{d.checks.map((c, i) => <div key={i} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`preflight-check-${i}`}><span className={`rounded-full px-1.5 py-0.5 font-semibold uppercase ${C[c.status]}`}>{c.status}</span><span className="font-medium text-slate-800">{c.check}</span><span className="text-slate-500">{c.detail}</span>{c.production_expected && <span className="text-slate-400">→ {c.production_expected}</span>}</div>)}</div>
        </>
      )}
    </div>
  );
}
